export const brandInfo = {
  name: '乐鱼官网',
  fullName: '乐鱼官方网站',
  slogan: '官方正版入口，安全可信赖',
  description: '乐鱼官网是您值得信赖的官方平台，致力于为用户提供安全、稳定、流畅的在线体验。作为行业领先的综合性娱乐内容平台，乐鱼始终秉持"用户至上、安全第一"的核心理念，以专业的技术团队和优质的服务体系，为数千万用户打造值得信赖的官方平台。',
  founded: '2015',
  location: '中国',
  contact: {
    email: 'service@leyu.com',
    phone: '400-888-0000',
    address: '中国上海市浦东新区陆家嘴金融贸易区',
    workingHours: '周一至周日 09:00 - 22:00',
  },
  values: [
    {
      title: '安全可信',
      description: '采用银行级加密技术，多重安全防护体系，全方位保障用户账户与信息安全，让每一位用户都能安心使用。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '稳定流畅',
      description: '全球部署高性能服务器集群，智能负载均衡技术，确保平台7×24小时稳定运行，提供流畅的使用体验。',
      icon: 'ri-rocket-line',
    },
    {
      title: '用户至上',
      description: '以用户需求为导向，持续优化产品功能与服务体验，专业的客服团队随时为用户提供贴心服务。',
      icon: 'ri-user-heart-line',
    },
    {
      title: '创新进取',
      description: '持续投入技术研发，紧跟行业发展前沿，不断引入新技术、新模式，为用户带来更优质的服务。',
      icon: 'ri-lightbulb-flash-line',
    },
  ],
  achievements: [
    { number: '1000万+', label: '注册用户' },
    { number: '8年+', label: '稳定运营' },
    { number: '99.9%', label: '平台可用率' },
    { number: '24/7', label: '客户服务' },
  ],
  faqs: [
    {
      question: '如何注册乐鱼官网账户？',
      answer: '点击页面右上角的"注册"按钮，按照提示填写手机号码、设置密码，完成短信验证即可成功注册。整个过程只需1分钟。',
    },
    {
      question: '乐鱼官网是否安全可靠？',
      answer: '乐鱼官网是经过官方认证的正规平台，采用银行级SSL加密技术，通过多重安全认证，全方位保障用户信息与资金安全，请您放心使用。',
    },
    {
      question: '忘记密码怎么办？',
      answer: '在登录页面点击"忘记密码"，通过绑定的手机号码或邮箱接收验证码，按照提示即可重置密码。如遇问题可联系在线客服协助处理。',
    },
    {
      question: '如何联系客服？',
      answer: '您可以通过以下方式联系我们的客服团队：在线客服（网站右下角）、客服热线 400-888-0000、官方邮箱 service@leyu.com。我们的客服团队全天候为您服务。',
    },
    {
      question: '平台支持哪些设备访问？',
      answer: '乐鱼平台支持PC端网页、移动端网页、iOS App和Android App等多种访问方式，您可以根据自己的需求选择合适的设备。所有平台数据同步，无缝切换。',
    },
  ],
};